import React, { createContext, useContext } from 'react';
const ContentNotesContext = createContext(false);
export function ContentNotesProvider({
  value,
  children
}: {
  value: boolean;
  children: React.ReactNode;
}) {
  return <ContentNotesContext.Provider value={value} data-id="element-254" data-mp="ajpwrfauhr2i">{children}</ContentNotesContext.Provider>;
}
export function useContentNotes(): boolean {
  return useContext(ContentNotesContext);
}